export const GTM_EVENTS = {
  INVOICE_CREATED: 'invoice_created',
  CARD_VERIFICATION: 'card_verification',
  PAYMENT_METHOD_VERIFICATION: 'payment_method_verification',
  CREATE_RTB_NETWORK: 'create_rtb_network',
  CREATE_RTB_ENDPOINT: 'create_rtb_endpoint',
  REG_ERROR: 'reg_error',
  REG_FORM_SUBMITTED_SUCCESSFULLY: 'reg_form_submitted_successfully',
  GOOGLE_SIGN_IN: 'google_sign_in',
  LOG_FORM_SUBMITED_SUCCESSFULLY: 'log_form_submited_successfully',
  CAMPAIGN_CREATED_SUCCESSFULLY: 'campaign_created_successfully',
  CAMPAIGN_CREATED_EDIT: 'campaign_created_edit',
  CAMPAIGN_CREATED_DUPLICATE: 'campaign_created_duplicate',
  CAMPAIGN_CREATED_UPSALE: 'campaign_created_upsale',
  CREATE_API_TOKEN: 'create_api_token',
  CREATE_CAMPAIGN_ALL_ERROR: 'create_campaign_all_error',
  PAYMENT_ERROR: 'payment_error',
  GENERATE_PUSH: 'generate_push',
  GENERATE_MULTIPOP: 'generate_multipop',
  GENERATE_LINK_CREATIVE: 'generate_link-creative',
  GENERATE_IN_PAGE: 'generate_in_page',
  AD_CREATED_SUCCESSFULLY: 'ad_created_successfully',
  CREATE_AD_ALL_ERRORS: 'create_ad_all_errors',
  USE_PRICEBOX_EDIT_PRICE: 'use_pricebox_edit_price',
  AUTOPAYMENT_ON: 'autopayment_on',
  AUTOPAYMENT_OFF: 'autopayment_off',
  AUTOPAYMENT_EDIT: 'autopayment_edit',
  SAVE_AUTOADJUST: 'save_autoadjust',
  EDIT_CAMPAIGN: 'edit_campaign',
  PLUS_MINUS_REC_BID: 'plus_minus_rec_bid',
  ADJUST_PRICE: 'adjust_price',
  AUTO_ADJUST_ON: 'Auto_adjust_on',
  AUTO_ADJUST_OFF: 'Auto_adjust_off',
  PROCCED_TO_BILLING: 'procced_to_billing',
  INVOICE_PAY: 'invoice_pay',
  PWA_INSTALL: 'pwa_install',
  START_CREATE_CAMPAIGN: 'start_create_campaign',
  OPEN_MARKETPLACE: 'open_marketplace',
  BUY_CARD: 'buy_card',
  BUY_CARD_SIMILAR: 'buy_card_similar',
  SEND_REQUEST: 'send_request',
  SEND_REQUEST_SPOT: 'send_request_spot',
  SEND_REQUEST_SIMILAR: 'send_request_similar',
  MARKETPLACE_FILTER: 'marketplace_filter',
  TRAFFIC_CHART_BUTTON_CREATE_CAMPAIGN: 'traffic_chart_button_create_campaign',
  TYPE_POPUNDER: 'type_popunder',
  TYPE_BANNER: 'type_banner',
  TYPE_WEBPUSH: 'type_webpush',
  TYPE_INSTREAM: 'type_instream',
  TYPE_NATIVE: 'type_native',
  TYPE_TABDIRECT: 'type_tabdirect',
  TYPE_INETRST: 'type_inetrst',
  TYPE_NOTWIDGET: 'type_notwidget',
  TYPE_GALLERYAD: 'type_galleryad',
  TYPE_INPAGE: 'type_inpage',
  L_7DAYS: 'L_7days',
  L_30DAYS: 'L_30days',
  L_WEEK: 'L_week',
  L_MONTH: 'L_month',
  N_7DAYS: 'n_7days',
  N_30DAYS: 'n_30days',
  N_WEEK: 'n_week',
  N_MONTH: 'n_month',
  C_WEEK: 'c_week',
  C_MONTH: 'c_month',
  CURRENT_WEEK_BEFORE: 'current_week_before',
  CURRENT_MONTH_BEFORE: 'current_month_before',
  PAGE_VIEW_UPSALE: 'page_view_upsale',
  CREATE_NEW_FORMAT: 'create_new_format',
  STEP_2_TIME_INTERVAL_CREATE_CAMPAIGN: 'step_2_time_interval_create_campaign',
  STEP_2_TIME_INTERVAL_EDIT_CAMPAIGN: 'step_2_time_interval_edit_campaign',
  COUNTRIES_TARGET: 'countries_target',
  REGIONS_TARGET: 'regions_target',
  CITIES_TARGET: 'cities_target',
  CONNECTION_TYPE_TARGET: 'connection_type_target',
  CARRIERS_TARGET: 'carriers_target',
  TRAFFIC_TYPE_TARGET: 'traffic_type_target',
  DEVICE_VENDORS_TARGET: 'device_vendors_target',
  DEVICE_MODELS_TARGET: 'device_models_target',
  LANGUAGES_TARGET: 'languages_target',
  BROWSERS_TARGET: 'browsers_target',
  OPERATING_SYSTEMS_TARGET: 'operating_systems_target',
  IP2_LOCATION_TYPES_TARGET: 'ip2_location_types_target',
  CAMPAIGN_ACTION_ACTIVATE: 'campaign_action_activate',
  CAMPAIGN_ACTION_PAUSE: 'campaign_action_pause',
  CAMPAIGN_ACTION_ARCHIVE: 'campaign_action_archive',
  CAMPAIGN_ACTION_EDIT: 'campaign_action_edit',
  CAMPAIGN_ACTION_DUPLICATE: 'campaign_action_duplicate',
  CAMPAIGN_ACTION_STATISTICS: 'campaign_action_statistics',
  CAMPAIGN_ACTION_IN_PROCESSING: 'campaign_action_in_processing',
  CAMPAIGN_ACTION_TABLE_ACTIVATE: 'campaign_action_table_activate',
  CAMPAIGN_ACTION_TABLE_PAUSE: 'campaign_action_table_pause',
  CAMPAIGN_ACTION_TABLE_ARCHIVE: 'campaign_action_table_archive',
  CAMPAIGN_ACTION_TABLE_EDIT: 'campaign_action_table_edit',
  CAMPAIGN_ACTION_TABLE_DUPLICATE: 'campaign_action_table_duplicate',
  CAMPAIGN_ACTION_TABLE_STATISTICS: 'campaign_action_table_statistics',
  CAMPAIGN_ACTION_TABLE_BANNER_ACTIVATE: 'campaign_action_table_banner_activate',
  CAMPAIGN_ACTION_TABLE_BANNER_PAUSE: 'campaign_action_table_banner_pause',
  CAMPAIGN_ACTION_TABLE_BANNER_ARCHIVE: 'campaign_action_table_banner_archive',
  CAMPAIGN_ACTION_TABLE_BANNER_DUPLICATE: 'campaign_action_table_banner_duplicate',
  TRACKING_INTEGRATION_ACTION: 'tracking_integration_action',
  USER_FORK_SHOW_BANNER: 'user_fork_show_banner',
  USER_FORK_BUTTON_CREATE_CAMPAIGN: 'user_fork_button_create_campaign',
  USER_FORK_BUTTON_CREATE_AD: 'user_fork_button_create_ad',
  USER_FORK_BUTTON_ADD_FUNDS: 'user_fork_button_add_funds',
  USER_FORK_SKIP_BANNER: 'user_fork_skip_banner',
  TELEGRAM_CLOSE_DIALOG: 'telegram_close_dialog',
  TELEGRAM_CLOSE_BANNER: 'telegram_close_banner',
  TELEGRAM_SUBSCRIBE_DIALOG: 'telegram_subscribe_dialog',
  TELEGRAM_SUBSCRIBE_BANNER: 'telegram_subscribe_banner',
  TELEGRAM_SUBSCRIBE_PROFILE: 'telegram_subscribe_profile',
  TELEGRAM_UNSUBSCRIBE: 'telegram_unsubscribe',
  IN_PAGE_SELECTED_SKIN: 'in_page_selected_skin',
  IN_PAGE_SELECTED_SKIN_GROUP: 'in_page_selected_skin_group',
  NO_CAMPAIGN_BUTTON_STATISTICS: 'no_campaign_button_statistics',
  CAMPAIGNS_ACTION_CREATE_CAMPAIGN: 'campaigns_action_create_campaign',
  CAMPAIGNS_ACTION_REFRESH: 'campaigns_action_refresh',
  CAMPAIGNS_ACTION_RESET: 'campaigns_action_reset',
  CAMPAIGNS_ACTION_SETTINGS_COLUMNS: 'campaigns_action_settings_columns',
  CAMPAIGNS_FILTERS: 'campaigns_filters',
  CONFIRM_EMAIL: 'confirm_email',
  CONFIRM_EMAIL_ERROR: 'confirm_email_error'
}

export const GTM_EVENTS_CATEGORY = {
  CREATED_AD: 'create_ad',
  REVENUE: 'revenue',
  PAYMENT: 'payment',
  RETENTION: 'retention',
  REGISTRATION: 'registration',
  CREATE_CAMPAIGN: 'create_campaign',
  PWA: 'PWA',
  FEATURE: 'feature',
  CALENDAR: 'calendar',
  PAGES: 'pages',
  STEP_2_CAMPAIGN: 'step_2_campaign',
  CAMPAIGN_ACTIONS: 'campaign_actions'
}
